import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from 'app/store/store';
import { BASE_URL } from 'app/utils/utils';
import i18next from 'i18next';

export const photoApi = createApi({
  reducerPath: 'photo',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/photo/versions/1',
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers: Headers, { getState }) => {
      const userInfo = (getState() as RootState).userSlice;
      headers.set('Accept-Language', i18next.resolvedLanguage ? i18next.resolvedLanguage : 'ru');

      if (userInfo?.auth && userInfo?.user) {
        headers.set('x-ais-user-csrf', userInfo.auth.value.csrfToken);
        headers.set('ais-user-csrf', userInfo.auth.value.csrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Photo'],

  endpoints: (build) => ({
    getVesselPhoto: build.query<any, number>({
      query: (imo) => ({
        url: `${imo}.webp`,
        responseHandler: (res) => res.blob(),
      }),
    }),
  }),
});
export const { useLazyGetVesselPhotoQuery } = photoApi;
